import { Dayjs } from 'date';
import { type InferType, type SchemaInput, yup } from 'form';
import { BaseTradeSignalSchema } from '../BaseTradeSignalSchema/BaseTradeSignalSchema';

export const SupplySignalSchema = BaseTradeSignalSchema.shape({
  last_collection_date: yup.mixed<Dayjs>().required(),
  material_grade_id: yup.number().when(['trade_company_lead_id'], ([tradeCompanyLeadId], schema) => {
    if (tradeCompanyLeadId) {
      return schema.required('Material grade is required.');
    }
    return schema.optional();
  }),
  material_spec_id: yup.number().when(['trade_company_lead_id'], ([tradeCompanyLeadId], schema) => {
    if (tradeCompanyLeadId) {
      return schema.required('Material is required.');
    }
    return schema.optional();
  }),
  port_of_loading_id: yup.number().optional(),
  sale_target_date: yup.mixed<Dayjs>().optional(),
  site_material_id: yup.number().when(['trade_company_id'], ([tradeCompanyId], schema) => {
    if (tradeCompanyId) {
      return schema.required('Site Material is required.');
    }
    return schema.optional();
  }),
  tonnes_per_load: yup.number().typeError('Tonnes per load must be a number').min(10).max(30).required(),
});

export type SupplySignalFormValues = InferType<typeof SupplySignalSchema>;
export type SupplySignalFormInputValues = SchemaInput<typeof SupplySignalSchema>;
